<div id="bonusRestrictionMsg" class="bonus-restriction-msg">
    <div class="overlay-text">
        <div class="trans-details">
            @if (isBwinBe) {
                <span>{{ 'PARTY.CASHIER.web.deposit.qd.reward.errorCode.108.be' | translate }}</span>
            } @else {
                @if (paymentMethod === 'VISA') {
                    <span>{{ 'PARTY.CASHIER.web.deposit.bonus.visa.errorCode.108' | translate }}</span>
                } @else if (paymentMethod === 'PAYPAL') {
                    <span>{{ 'PARTY.CASHIER.web.deposit.qd.bonus.errorCode.108' | translate }}</span>
                }
            }
            <div class="space-between mt-2">
                <button type="button" class="btn btn-secondary" (click)="submitDepositFromPopup('paypalBonus')">
                    {{ 'PARTY.CASHIER.web.deposit.qd.msg.yes' | translate }}
                </button>

                <button type="button" class="btn btn-primary" (click)="closeAlertPopup()">
                    {{ 'PARTY.CASHIER.web.deposit.qd.msg.no' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
